export default "__VITE_ASSET__29046f1e__"